export enum MeasureType {
  ADHERENCE = "ADH",
  COMMUNICATION = "COM",
  DISCHARGE = "DSC",
  ELIGIBILITY = "ELG",
  GAP = "GAP",
  HEALTH_RISK_ASSESSMENT = "HRA",
  HIGH_COST_HIGH_NEEDS = "HCN",
}
export enum GapLogType {
  OFFICE_COMMENT = "OCO",
  PATIENT_COMMENT = "PCO",
  PATIENT_ACKNOWLEDGED_SMS_NOTIFICATION = "PAS",
  PROVIDER_COMMENT = "PRC",
}
export enum MessageType {
  ANY = "",
  VOICE = "VOICE",
  SMS = "SMS",
}
export enum GapStatus {
  NEW = "PEN",
  WORKING = "WRK",
  CLOSED = "CLD",
}
export enum GapSubStatus {
  COMPLETED = "CPT",
  ATTENDED = "ATD",
  VISITED = "VIS",
}
export enum PatientLogType {
  OFFICE_COMMENT = "OCO",
}
// SCHEDULE
export enum ScheduleView {
  Calendar,
  Group,
  List,
}
export enum ScheduleType {
  REGULAR = "APT",
  SERVICE = "SRV",
  DELIVERY = "DLV",
  READY_RESPONDERS = "RRS",
}
export enum ScheduleSession {
  MORNING = "MN",
  NOON = "NN",
  AFTERNOON = "AN",
  NIGHT = "NT",
  ANY_TIME = "XX",
}
export enum ScheduleStatus {
  ASSIGNED_TO_DRIVER = 20,
  ACCEPTED_BY_DRIVER = 21,
  REJECTED_BY_DRIVER = 22,
  OUT_FOR_DELIVERY = 23,
  DELIVERED = 24,
  UNDELIVERED = 25,
  ASSIGNED_TO_MED_ASSISTANT = 26,
  ACCEPTED_BY_MED_ASSISTANT = 27,
  REJECTED_BY_MED_ASSISTANT = 28,
  OUT_FOR_SERVICE = 29,
  COMPLETED = 15,
  NOT_COMPLETED = 30,
}
export enum ScheduleLogType {
  OFFICE_COMMENT = "OCO",
  PATIENT_COMMENT = "PCO",
  DRIVER_COMMENT = "DRC",
}
// CALLS
export enum CallLogType {
  OFFICE_COMMENT = "OCO",
  OFFICE_TO_CALLER_MESSAGE = "OCM",
  CALLER_TO_OFFICE_MESSAGE = "COM",
  SECURE_CHAT_PHOTO = "SCP",
  SECURE_CHAT_VOICE = "SCV",
  SECURE_CHAT_FILE = "SCF",
  ERROR = "ERR",
}
export interface CallLogEntry {
  id?: string;
  publicId: string;
  typeId: CallLogType;
  comment?: string;
}
